/**
 * @ngdoc controllers
 * @memberof mercury.modules.time
 * @name TimeStaffAddPosBulkCtrl
 */
angular.module('mercury.modules.time.staff')
.controller('TimeStaffAddPosBulkCtrl', ["$filter", "$q", "$scope", "ReportPosStaff", "TimeRoles", "TimeStaff", function($filter, $q, $scope, ReportPosStaff, TimeRoles, TimeStaff) {
  $scope.filerName = '';
  $scope.showDeleted = false;
  $scope.noRolesError = false;
  var savePending = false;

  $scope.loading = $q.all({
    roles: TimeRoles.getAllActive(),
    posStaff: ReportPosStaff.getAllUnlinked()
  });

  $scope.loading.then(function(results) {
    $scope.newStaff = [];
    angular.forEach(results.posStaff, function(posStaffMember) {
      var newStaff = {
        posStaffName: posStaffMember.firstName + ' ' + (posStaffMember.lastName || ''),
        posIdentifier: posStaffMember.posIdentifier,
        isDeleted: posStaffMember.isDeleted,
        firstName: posStaffMember.firstName,
        lastName: posStaffMember.lastName,
        memberRoles: [{
          hourlyRate: posStaffMember.hourlyRate
        }],
        roleOptions: angular.copy(results.roles),
        showInRoster: true
      };

      var posRole = $filter('filter')(results.roles, {posIdentifier: posStaffMember.roleIdentifier})[0];
      if (posRole) {
        newStaff.defaultRoleId = posRole.id;
        newStaff.memberRoles[0].roleId = posRole.id;
        newStaff.selectedRole = newStaff.roleOptions[results.roles.indexOf(posRole)];
      } else {
        // The staff POS role doesn't exist in the company so, if it's a valid role, add a Temp POS Role
        // which will be created when the staff member is saved.
        if (posStaffMember.roleIdentifier != null) {
          var newRole = {
            name: posStaffMember.roleName,
            posIdentifier: posStaffMember.roleIdentifier
          };

          newStaff.memberRoles[0].role = newRole;
          newStaff.roleOptions.push(newRole);
          newStaff.selectedRole = newStaff.roleOptions[newStaff.roleOptions.length - 1];
        } else {
          if (results.roles.length > 0) {
            newStaff.defaultRoleId = results.roles[0].id;
            newStaff.memberRoles[0].roleId = results.roles[0].id;
            newStaff.selectedRole = newStaff.roleOptions[0];
          } else {
            $scope.noRolesError = true;
          }
        }
      }

      $scope.newStaff.push(newStaff);

    });

    $scope.roles = results.roles;
  });

  $scope.roleChanged = function(staff) {
    var newRole = staff.selectedRole;

    staff.defaultRoleId = newRole.id;
    staff.memberRoles[0].roleId = newRole.id;

    if (!newRole.id) {
      staff.memberRoles[0].role = newRole;
    }
  };

  $scope.addStaff = function(staff, index) {
    $scope.staffBulkForm.$setSubmitted();
    // Index will be null if this is a recursive call. We don't need to validate in that case.
    if (index !== null &&
      (
        $scope.staffBulkForm['firstName' + index].$invalid ||
        $scope.staffBulkForm['lastName' + index].$invalid ||
        ($scope.staffBulkForm['hourlyRate' + index] && $scope.staffBulkForm['hourlyRate' + index].$invalid)
      )) {
      return;
    }

    // Add a promise so the 'Add' button will get a loading spinner.
    staff.saving = $q.defer();

    // If we are currently saving another staff member, do nothing becuase this save will be completed after the pending one.
    if (savePending === false) {
      savePending = true;
      //Chain the saving promise.
      staff.saving.resolve(TimeStaff.create(staff));
      staff.saving.promise.then(function(savedMember) {
        // Call the parents controller method to the new staff member is added to the list.
        $scope.staffAdded(savedMember);

        // Remove the staff member we just added.
        angular.forEach($scope.newStaff, function(newStaff, index) {
          if (newStaff.posIdentifier == staff.posIdentifier) {
            $scope.newStaff.splice(index, 1);
          }
        });

        // Adding this staff resulted in a new Role. Go through an update all the Temp
        // POS roles with the actual roleId so we don't try to create it again.
        if (!staff.defaultRoleId) {
          var savedRolePosIdentifier = staff.memberRoles[0].role.posIdentifier;
          var newRoleId = savedMember.defaultMemberRoleRoleId;

          angular.forEach($scope.newStaff, function(newStaff) {
            angular.forEach(newStaff.roleOptions, function(role, optionIndex) {
              if (role.posIdentifier == savedRolePosIdentifier) {
                newStaff.roleOptions.splice(optionIndex, 1, {
                  id: newRoleId,
                  name: role.name,
                  posIdentifier: role.posIdentifier
                });

                if (!newStaff.defaultRoleId) {
                  newStaff.defaultRoleId = newRoleId;
                  newStaff.memberRoles[0].roleId = newRoleId;
                  delete newStaff.memberRoles[0].role;
                }
              }
            });
          });
        }
      }).finally(function() {
        staff.saving = null;
        savePending = false;

        // Check if there are other staff waiting to be saved and if so, call addStaff on them.
        angular.forEach($scope.newStaff, function(newStaff) {
          if (newStaff.saving && savePending === false) {
            $scope.addStaff(newStaff, null);
          }
        });
      });
    }
  };
}]);
